import { useContext, useMemo } from "react";
import { AuthContext } from "../context/auth.context";
import type { JwtPayload } from "../types/auth";
import { isAdmin } from "../utils/authRoles";

export const useUserRoles = () => {
  const { user } = useContext(AuthContext);
  const payload = user as JwtPayload | null | undefined;

  return useMemo(
    () => ({
      user: payload,
      isAdmin: isAdmin(payload),
    }),
    [payload]
  );
};
